export const businessTypes = [
  {
    label: 'Boarding.Business_types.retail',
    options: [
      {
        label: 'Boarding.Business_types.retail_clothing_accessories',
        value: 'retail-clothing-accessories',
      },
      {
        label: 'Boarding.Business_types.retail_health_beauty',
        value: 'retail-health-beauty',
      },
      {
        label: 'Boarding.Business_types.retail_electronics',
        value: 'retail-electronics',
      },
      {
        label: 'Boarding.Business_types.retail_specialty_foods',
        value: 'retail-specialty-foods',
      },
      {
        label: 'Boarding.Business_types.retail_home_garden',
        value: 'retail-home-garden',
      },
      {
        label: 'Boarding.Business_types.retail_jewelry_watches',
        value: 'retail-jewelry-watches',
      },
      {
        label: 'Boarding.Business_types.retail_sporting_goods',
        value: 'retail-sporting-goods',
      },
      {
        label: 'Boarding.Business_types.retail_convenience_stores',
        value: 'retail-convenience-stores',
      },
      {
        label: 'Boarding.Business_types.retail_vape_tobacco_shops',
        value: 'retail-vape-tobacco-shops',
      },
      {
        label: 'Boarding.Business_types.retail_liquor_stores',
        value: 'retail-liquor-stores',
      },
      {
        label: 'Boarding.Business_types.retail_pet_food_supplies',
        value: 'retail-pet-food-supplies',
      },
      { label: 'Boarding.Business_types.retail_other', value: 'retail-other' },
    ],
  },
  {
    label: 'Boarding.Business_types.restaurant',
    options: [
      {
        label: 'Boarding.Business_types.restaurant_quick_service',
        value: 'restaurant-quick-service',
      },
      {
        label: 'Boarding.Business_types.restaurant_table_service',
        value: 'restaurant-table-service',
      },
      {
        label: 'Boarding.Business_types.restaurant_counter_service',
        value: 'restaurant-counter-service',
      },
      {
        label: 'Boarding.Business_types.restaurant_bar_lounge',
        value: 'restaurant-bar-lounge',
      },
      {
        label: 'Boarding.Business_types.restaurant_cafe_coffee_shop',
        value: 'restaurant-cafe-coffee-shop',
      },
      {
        label: 'Boarding.Business_types.restaurant_bakery_pastry_shop',
        value: 'restaurant-bakery-pastry-shop',
      },
      {
        label: 'Boarding.Business_types.restaurant_food_truck',
        value: 'restaurant-food-truck',
      },
      {
        label: 'Boarding.Business_types.restaurant_brewery_taproom',
        value: 'restaurant-brewery-taproom',
      },
      {
        label: 'Boarding.Business_types.restaurant_ice_cream_dessert_shop',
        value: 'restaurant-ice-cream-dessert-shop',
      },
      {
        label: 'Boarding.Business_types.restaurant_other',
        value: 'restaurant-other',
      },
    ],
  },
  {
    label: 'Boarding.Business_types.services',
    options: [
      {
        label: 'Boarding.Business_types.services_salon_spa',
        value: 'services-salon-spa',
      },
      {
        label: 'Boarding.Business_types.services_barber_shop',
        value: 'services-barber-shop',
      },
      {
        label: 'Boarding.Business_types.services_fitness_wellness',
        value: 'services-fitness-wellness',
      },
      {
        label: 'Boarding.Business_types.services_personal_training',
        value: 'services-personal-training',
      },
      {
        label: 'Boarding.Business_types.services_medical_dental',
        value: 'services-medical-dental',
      },
      {
        label: 'Boarding.Business_types.services_veterinary_clinics',
        value: 'services-veterinary-clinics',
      },
      {
        label: 'Boarding.Business_types.services_auto_repair_maintenance',
        value: 'services-auto-repair-maintenance',
      },
      {
        label: 'Boarding.Business_types.services_dry_cleaning_laundry',
        value: 'services-dry-cleaning-laundry',
      },
      {
        label: 'Boarding.Business_types.services_home_services',
        value: 'services-home-services',
      },
      {
        label: 'Boarding.Business_types.services_other',
        value: 'services-other',
      },
    ],
  },
];

export enum MonthlyRevenueRange {
  LessThan10k = '0-10k',
  Between10kAnd20k = '10k-20k',
  Between20kAnd50k = '20k-50k',
  MoreThan50k = '50k+',
}

export const features = [
  'Boarding.feature_1',
  'Boarding.feature_2',
  'Boarding.feature_3',
  'Boarding.feature_4',
];

export type RegistrationState = {
  business: string;
  platform: string;
  type: string;
  averageRevenue: string;
};

export enum Step {
  Step1 = 1,
  Step2,
  Step3,
  Step4,
  Step5,
}

export type SetRegistration = (updater: (state: RegistrationState) => RegistrationState) => void;

export type NextStepFunction = () => void;
export type PrevStepFunction = () => void;
